export default function registerCnLiveChat($, apower) {
  $.register("cn-live-chat", {
    template: `<div class="cn-live-chat" @click="onClick">
		<img src="{{img}}" width="{{width}}" height="{{height}}"></img>
		</div>`,
    frameTemplate: `<div class="cn-live-chat-iframe">
			<div class="chat-close" @click="closeChat"><svg viewBox="0 0 12 12"><line x1="1" y1="1" x2="11" y2="11" style="stroke-width: 2; stroke-linecap: round; stroke-linejoin: round;"></line><line x1="11" y1="1" x2="1" y2="11" style="stroke-width: 2; stroke-linecap: round; stroke-linejoin: round;"></line></svg></div>
			<span class="cover-title" style="width: 100%;height: 40px;line-height: 40px;position: relative;top: 0;left: 0;z-index: 10;text-align: center;margin: 0;font-size: 16px;font-weight: 400;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: block;">客服助手</span>
			<iframe src="{{chaturl}}"></iframe>
		</div>`,
    props: ["width", "height", "bottom", "right", "img", "chaturl"],
    width: 80,
    height: 80,
    bottom: 12,
    right: 12,
    chaturl: "",
    img: "",
    iframeEl: "",
    onReady() {
      this.el.css("position", "fixed");
      this.el.css("cursor", "pointer");
      this.el.css("width", this.width + "px");
      this.el.css("height", this.height + "px");
      this.el.css("bottom", this.bottom + "px");
      this.el.css("right", this.right + "px");
      this.el.css("border-radius", "100%");
      this.el.css("overflow", "hidden");
    },
    onClick() {
      if (!this.iframeEl) {
        this.iframeEl = this.createFromTemplate(this.frameTemplate);
        this.iframeEl.css({
          position: "fixed",
          top: "0",
          right: "0",
          height: "100vh",

          width: "340px",
          "box-shadow": "rgb(27 33 58 / 40%) 0px 20px 60px -2px",
          "border-radius": "0px",
          "z-index": 1001,
          background: " #f5f5f9",
        });
        this.iframeEl.find("iframe").css({
          height: "calc( 100% - 40px)",
          width: "100%",
          border: "none",
          "border-top": "1px solid #13c2c2",
        });
        this.iframeEl.find(".chat-close").css({
          position: "absolute",
          top: "5px",
          right: "5px",
          "z-index": 200,
          width: "30px",
          height: "30px",
          "border-radius": "50%",
          cursor: "pointer",
          background: "#fff",
          display: "flex",
          "justify-content": "center",
          "-webkit-box-align": "center",
          "-ms-flex-align": "center",
          "align-items": "center",
        });
        this.iframeEl.find(".chat-close svg").css({
          stroke: "currentColor",
          width: "42%",
          height: "42%",
        });
      }
      this.iframeEl.appendTo($("body"));
    },
    closeChat() {
      if (this.iframeEl && this.iframeEl.parent()) {
        this.iframeEl.parent()[0].removeChild(this.iframeEl[0]);
      }
    },
  });
}
